import { StatusBar } from 'native-base'
import { useEffect, useState } from 'react'
import PersonalizationForm from '../../components/onboarding/PersonalizationForm'
import FormLayout from '../../layouts/FormLayout'
import { useCabanaApi } from '../../providers/CabanaApiProvider'
import LoadingScreen from '../LoadingScreen'

const PersonalizationScreen = ({ navigation }) => {
  const {
    MemberProfileApi: { profile },
  } = useCabanaApi()
  const [profileData, setProfileData] = useState(null)

  const getProfileData = async () => {
    const userProfile = await profile()
    setProfileData(userProfile)
  }

  // Get profile data
  useEffect(() => {
    getProfileData()
  }, [])

  return (
    <>
      {profileData ? (
        <FormLayout autoBackButton={false}>
          <StatusBar barStyle="dark-content" />
          <PersonalizationForm
            key={JSON.stringify(profileData)}
            profileData={profileData}
          />
        </FormLayout>
      ) : (
        <LoadingScreen />
      )}
    </>
  )
}

export default PersonalizationScreen
